export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="mb-6 capitalize flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="text-headline-md text-on-surface">{title}</h1>
        {subtitle && <p className="mt-1 text-body-sm text-on-surface-variant">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2.5">{actions}</div>}
    </div>
  );
}
